import axios from 'axios';

import { responseInterceptor, errorInterceptor } from './interceptors';
import { Environment } from '../../../environments';
import { LoadingService } from '../../loading/loadingService';

const Api = axios.create({
    baseURL: Environment.URL_BASE,
});

Api.interceptors.request.use(
    (config) => {
        LoadingService.start();
        const token = localStorage.getItem('APP_ACCESS_TOKEN');

        if (token) {
            config.headers = config.headers || {};
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => Promise.reject(error),
);

Api.interceptors.response.use(
    (response) => {
        LoadingService.stop();
        return responseInterceptor(response);
    },
    (error) => {
        LoadingService.stop();
        return errorInterceptor(error);
    },
);

export { Api };
